import styled from 'styled-components';

export default styled.div`
  /* Base CTA Styles */
  .smartplayer__cta {
    position: absolute;
    z-index: 95;
    opacity: 0;
    transform: translateY(10px);
    animation: ctaFadeIn 0.4s ease-out forwards;
    pointer-events: auto;
  }

  @keyframes ctaFadeIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .smartplayer__ctaButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border-radius: 8px;
    font-family: inherit;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;
    border: 0;
    outline: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(4px);

    &:hover {
      /* transform: translateY(-1px); */
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    &:focus {
      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
    }
  }

  .smartplayer__ctaText {
    line-height: 1;
  }

  /* Position Variants */

  /* Top Positions */
  .smartplayer__cta--top-left {
    top: 16px;
    left: 16px;
  }

  .smartplayer__cta--top-center {
    top: 16px;
    left: 50%;
    transform: translateX(-50%) translateY(10px);

    &.smartplayer__cta {
      animation: ctaFadeInCenter 0.4s ease-out forwards;
    }
  }

  .smartplayer__cta--top-right {
    top: 16px;
    right: 16px;
  }

  /* Middle Positions */
  .smartplayer__cta--mid-left {
    top: 50%;
    left: 16px;
    transform: translateY(-50%) translateY(10px);

    &.smartplayer__cta {
      animation: ctaFadeInMiddle 0.4s ease-out forwards;
    }
  }

  .smartplayer__cta--mid-center {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) translateY(10px);

    &.smartplayer__cta {
      animation: ctaFadeInMiddleCenter 0.4s ease-out forwards;
    }
  }

  .smartplayer__cta--mid-right {
    top: 50%;
    right: 16px;
    transform: translateY(-50%) translateY(10px);

    &.smartplayer__cta {
      animation: ctaFadeInMiddle 0.4s ease-out forwards;
    }
  }

  /* Bottom Positions */
  .smartplayer__cta--bottom-left {
    bottom: 80px;
    left: 16px;
  }

  .smartplayer__cta--bottom-center {
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%) translateY(10px);

    &.smartplayer__cta {
      animation: ctaFadeInCenter 0.4s ease-out forwards;
    }
  }

  .smartplayer__cta--bottom-right {
    bottom: 80px;
    right: 16px;
  }

  /* Size Variants */

  /* Small Size */
  .smartplayer__cta--sm .smartplayer__ctaButton {
    padding: 6px 12px;
    font-size: 12px;
    min-height: 28px;
  }

  /* Medium Size (Default) */
  .smartplayer__cta--md .smartplayer__ctaButton {
    padding: 8px 16px;
    font-size: 14px;
    min-height: 36px;
  }

  /* Large Size */
  .smartplayer__cta--lg .smartplayer__ctaButton {
    padding: 12px 24px;
    font-size: 16px;
    min-height: 44px;
  }

  /* Animation Variants for Different Positions */
  @keyframes ctaFadeInCenter {
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  @keyframes ctaFadeInMiddle {
    to {
      opacity: 1;
      transform: translateY(-50%);
    }
  }

  @keyframes ctaFadeInMiddleCenter {
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(-50%);
    }
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .smartplayer__cta--top-left,
    .smartplayer__cta--mid-left,
    .smartplayer__cta--bottom-left {
      left: 12px;
    }

    .smartplayer__cta--top-right,
    .smartplayer__cta--mid-right,
    .smartplayer__cta--bottom-right {
      right: 12px;
    }

    .smartplayer__cta--top-left,
    .smartplayer__cta--top-center,
    .smartplayer__cta--top-right {
      top: 12px;
    }

    .smartplayer__cta--bottom-left,
    .smartplayer__cta--bottom-center,
    .smartplayer__cta--bottom-right {
      bottom: 70px;
    }

    /* Adjust sizes for mobile */
    .smartplayer__cta--lg .smartplayer__ctaButton {
      padding: 10px 20px;
      font-size: 15px;
      min-height: 40px;
    }

    .smartplayer__cta--md .smartplayer__ctaButton {
      padding: 7px 14px;
      font-size: 13px;
      min-height: 32px;
    }

    .smartplayer__cta--sm .smartplayer__ctaButton {
      padding: 5px 10px;
      font-size: 11px;
      min-height: 24px;
    }
  }

  @media (max-width: 480px) {
    .smartplayer__cta--top-left,
    .smartplayer__cta--mid-left,
    .smartplayer__cta--bottom-left {
      left: 8px;
    }

    .smartplayer__cta--top-right,
    .smartplayer__cta--mid-right,
    .smartplayer__cta--bottom-right {
      right: 8px;
    }

    .smartplayer__cta--top-left,
    .smartplayer__cta--top-center,
    .smartplayer__cta--top-right {
      top: 8px;
    }

    .smartplayer__cta--bottom-left,
    .smartplayer__cta--bottom-center,
    .smartplayer__cta--bottom-right {
      bottom: 60px;
    }

    /* Smaller sizes for very small screens */
    .smartplayer__cta--lg .smartplayer__ctaButton {
      padding: 8px 16px;
      font-size: 14px;
      min-height: 36px;
    }

    .smartplayer__cta--md .smartplayer__ctaButton {
      padding: 6px 12px;
      font-size: 12px;
      min-height: 28px;
    }

    .smartplayer__cta--sm .smartplayer__ctaButton {
      padding: 4px 8px;
      font-size: 10px;
      min-height: 20px;
    }
  }

  /* Prevent CTA from interfering with video controls */
  .smartplayer__cta--bottom-left,
  .smartplayer__cta--bottom-center,
  .smartplayer__cta--bottom-right {
    pointer-events: auto;
  }

  /* Ensure proper stacking */
  .smartplayer__cta {
    z-index: 95; /* Above video but below some UI elements */
  }

  /* Multiple CTAs spacing */
  .smartplayer__cta + .smartplayer__cta {
    margin-top: 8px;
  }

  /* Special handling for center positions with multiple CTAs */
  .smartplayer__cta--top-center + .smartplayer__cta--top-center,
  .smartplayer__cta--mid-center + .smartplayer__cta--mid-center,
  .smartplayer__cta--bottom-center + .smartplayer__cta--bottom-center {
    margin-top: 12px;
  }
`;
